import { useQuery } from "@tanstack/react-query";
import { getAudioGuideAvailability } from "@/lib/audio-guides.functions";

/** ¿Existe una audioguía real publicada para este tour? (sin IA, una consulta compartida). */
export function usePublishedGuide(tourSlug: string | null | undefined) {
  const { data } = useQuery({
    queryKey: ["published-audio-guide", tourSlug ?? ""],
    queryFn: () => getAudioGuideAvailability({ data: { tourSlug: tourSlug! } }),
    enabled: !!tourSlug,
    staleTime: 5 * 60_000,
  });
  return !!data?.exists;
}

export const FIRST_CHAPTER_FREE: Record<string, string> = {
  es: "Escuchar el primer capítulo gratis",
  en: "Listen to the first chapter free",
  fr: "Écouter le premier chapitre gratuitement",
  de: "Erstes Kapitel kostenlos anhören",
  it: "Ascolta gratis il primo capitolo",
  pt: "Ouvir o primeiro capítulo grátis",
};
